// Форматирование чисел/хешей для UI.

/** Баланс/суммы: до 2 знаков, с разделителями тысяч, без хвостовых нулей. */
export function formatTon(value: string | number): string {
  const n = typeof value === 'string' ? parseFloat(value) : value;
  if (!isFinite(n)) return '0';
  return n.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
}

/** Бросок всегда с 2 знаками: 7 -> "7.00". */
export function formatRoll(value: number): string {
  return value.toFixed(2);
}

/** Сократить хеш для компактного показа. */
export function shortHash(h: string, head = 10): string {
  if (!h) return '';
  return h.length > head + 6 ? `${h.slice(0, head)}…${h.slice(-4)}` : h;
}
